import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

import logoUrl from '../../assets/checkmark.svg';
import group$$ from '../../assets/group$$.svg';
import group$ from '../../assets/group$.svg';
import { metricValueFormat } from '../../utils/metricValueFormat';
import { EmployeeMetricStatus, IMonthlyMetric, MetricProgressData } from '../../utils/types';
import './metricProgress.scss';

type metrickProgress = {
    data?: MetricProgressData[],
    selectedmetrics?: EmployeeMetricStatus
}

export const MetricProgress = ({data, selectedmetrics}: metrickProgress) => {
    const [empMetricSeries, setEmpMetricSeries] = useState<any>([]);
    const [selectedMonth, setselectedMonth] = useState<string>();
    const [metricDetails, setMetricDetails] = useState<object>({});
    const [metricVals, setMetricVals] = useState(0);
    const [metricTargetVals, setmetricTargetVals] = useState(0);
    const [metricReported, setmetricReported] = useState(0);
    const [monthlyMetricsDetails, setmonthlyMetricsDetails] = useState<MetricProgressData[]>();    
    const [uniqueKey, setUniqueKey] = useState<string>('');

    let metricdetailslist: IMonthlyMetric[];
    const seriesArr: number[] = [];
    let MetricDetails: any;


    useEffect(() => {
        setMetricDetails({});
        setEmpMetricSeries([]);

        if (selectedmetrics) {
            setMetricVals(selectedmetrics.total_metrics_targeted);
            setmetricTargetVals(
                selectedmetrics.total_metrics_targeted - selectedmetrics.total_metrics_attained
            );
            setmetricReported(selectedmetrics.total_metrics_reported);
        }

        if (data) {
            const key = `${data[0]?.employee_number}-${data[0]?.selected_month}-${data[0]?.scorecard_version_id}`;
            setUniqueKey(key);
            metricdetailslist = { ...data };
            setselectedMonth(metricdetailslist[0]?.selected_month);
            if (seriesArr.length === 0) {
                data?.forEach((element?: any) => {
                    let mtval: number;
                    if (element?.metric_value !== null) {
                        if (element?.target < element?.metric_value) {
                            mtval = 100;
                            seriesArr.push(mtval);
                        } else {
                            mtval = (element.metric_value / element.target) * 100;
                            seriesArr.push(Number(mtval.toFixed(2)));
                        }
                    }
                });
            }
            setEmpMetricSeries(seriesArr);
            if (metricdetailslist[0]?.metric_value !== undefined && selectedmetrics !== null) {
                MetricDetails = {
                    series: [
                        metricdetailslist[0].metric_value?.toFixed(2),
                        metricdetailslist[1].metric_value?.toFixed(2),
                        metricdetailslist[2].metric_value?.toFixed(2),
                        metricdetailslist[3]?.metric_value?.toFixed(2),
                        metricdetailslist[4]?.metric_value?.toFixed(2),
                        metricdetailslist[5]?.metric_value?.toFixed(2),
                    ],
                    options: {
                        chart: {
                            height: 350,
                            type: 'radialBar',
                        },
                        plotOptions: {
                            radialBar: {
                                dataLabels: {
                                    name: {
                                        fontSize: '22px',
                                    },
                                    value: {
                                        fontSize: '16px',
                                    },
                                    total: {
                                        show: true,
                                        /* label: '', */
                                        fontWeight: 600,
                                        // label: `${selectedmetrics.total_metrics_attained}/${selectedmetrics.total_metrics_reported}`,
                                        formatter: () =>
                                            `${selectedmetrics?.total_metrics_attained}/${selectedmetrics?.total_metrics_reported}`,
                                    },
                                },
                            },
                        },
                        labels: [
                            metricdetailslist[0].label,
                            metricdetailslist[1].label,
                            metricdetailslist[2].label,
                            metricdetailslist[3]?.label,
                            metricdetailslist[4]?.label,
                            metricdetailslist[5]?.label,
                        ],
                        colors: ['#1A5AA5', '#3299FF', '#00D6BB', '#C4FF85', '#BADDFF','#f5ab76'],
                    },
                };
            }
            if (MetricDetails?.options) setMetricDetails(MetricDetails.options);
            setmonthlyMetricsDetails(data);
        }
    }, [data, selectedmetrics]);
    let displayimg: string;
    let targetValue: string;
    let metricValue: string;

    const targetMetricValueBodyTemplate = (rowData: IMonthlyMetric, type: string) => {
        if (rowData && type === 'target') {
            targetValue = metricValueFormat(rowData.target, rowData.metric_type_name);
        } else if (rowData && type === 'metric_value') {
            metricValue = metricValueFormat(rowData.metric_value, rowData.metric_type_name);
        } else if (rowData && type === 'label') {
            displayimg = 'metric' + rowData.metric_index;
        }

        return (
            <>
                {type === 'target' &&<span className="image-text">{targetValue === 'undefined' ? '0.00%': targetValue}</span>}
                {type === 'metric_value' && <span className="image-text">{metricValue === 'undefined' ? '0.00%': metricValue}</span>}
                {
                    rowData.metric_attained && type === 'metric_attained' && (<img className="justify-content-left " src={logoUrl} alt="Empower" />)
                }
                {
                    rowData && type === 'label' && (
                        <div className="flex align-items-center gap-2">
                            <span className={displayimg} />
                            <span className="imagespacing">{rowData.label}</span>
                        </div>
                    )
                }
            </>
        )
    };


    return (
        <>
            <h6
                style={{
                    color: '#2B3A42',
                    fontSize: '20px',
                    fontFamily: 'Urbanist',
                    fontWeight: 600,
                }}
            >
                Month to Date Metric Progress
            </h6>

            <div className="card h-100">
                <div className="card-body">
                    <div className="row" style={{ backgroundColor: 'white' }}>
                        <span
                             style={{
                                color: '#2B3A42',
                                fontSize: '24px',
                                fontFamily: 'Urbanist',
                                fontWeight: 600,
                                // paddingLeft: '70px',
                            }} 
                        >
                            {selectedMonth}
                        </span>
                        <div className="col-md-5" id="chart" style={{ borderRight: '1px solid #CECECD' }}>
                            {metricDetails && empMetricSeries?.length > 0 ? (
                                <ReactApexChart
                                    key={JSON.stringify(uniqueKey)}
                                    options={metricDetails}
                                    series={empMetricSeries}
                                    type="radialBar"
                                    height={251}
                                />
                            ): <p className="no-met-metrics">You have not met any metrics yet.</p>}

                            {
                                metricTargetVals !== undefined && metricTargetVals > 0  ? (
                                    <div className="container2 rounded">
                                        <div>
                                            <img className="iconDetails" src={group$} alt="TTEC" />
                                        </div>
                                        <div className='description-container'>
                                            <div
                                                style={{
                                                    fontSize: '13px',
                                                    fontWeight: 'bold',
                                                    color: '#2B3A42',
                                                }}
                                            >
                                                <p>
                                                    You are just{' '}
                                                    <span className='description-text'>
                                                        {metricTargetVals}
                                                    </span>
                                                    { } {metricTargetVals > 1 ? 'metrics' : 'metric'} away from qualifying for minimum payout!
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ): ''
                            }
                            
                        </div>
                        <div className="col-md-7 ps-2 mx-auto">
                            <div className="card border-0 metricprogresstable">
                                <DataTable value={monthlyMetricsDetails}>
                                    <Column field="label" header="Metric" body={(rowData) => targetMetricValueBodyTemplate(rowData, 'label')} />
                                    <Column
                                        field="target"
                                        header="Target"
                                        className='target-metric-value-column'
                                        body={(rowData) => targetMetricValueBodyTemplate(rowData, 'target')}
                                    />
                                    <Column
                                        field="metric_value"
                                        header="Actual"
                                        className='target-metric-value-column'
                                        body={(rowData) => targetMetricValueBodyTemplate(rowData, 'metric_value')}
                                    />
                                    <Column
                                        field="metric_attained"
                                        header="Met"
                                        dataType="boolean"
                                        style={{ width: '50px' }}
                                        body={(rowData) => targetMetricValueBodyTemplate(rowData, 'metric_attained')}
                                        className="metricmet metric-attained-column"
                                    />
                                </DataTable>
                            </div>

                            <div
                                className="rounded mt-4"
                                style={{
                                    padding: '10px',
                                    backgroundColor: '#E0F0FF',
                                }}
                            >
                                <div className='table-description-view'>
                                    <img
                                        className='img-style'
                                        src={group$}
                                        alt="TTEC"
                                    />{' '}
                                    Meet{' '}
                                    <span className='dynamic-text'>
                                        {metricVals}
                                    </span>{' '}
                                    metrics to qualify{' '}
                                    <span className='table-description-text'>
                                        minimum{' '}
                                    </span>
                                    payout.
                                </div>
                                <p />
                                <div className='table-description-view'>
                                    <img
                                        className='img-style'
                                        src={group$$}
                                        alt="TTEC"
                                    />{' '}
                                    Meet all{' '}
                                    <span className='dynamic-text'>
                                        {metricReported}
                                    </span>{' '}
                                    metrics to qualify for{' '}
                                    <span className='table-description-text'>
                                        maximum
                                    </span>{' '}
                                    payout.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
